import dayjs from 'dayjs';
import type { IOcrTestRun } from '@/types';

/** Share of a run's cases that passed, as a whole percentage (0 for an empty run). */
export const passRate = (run: IOcrTestRun): number =>
  run.totalCases > 0 ? Math.round((run.passedCases / run.totalCases) * 100) : 0;

/** The tone of a pass rate: all passed, most passed, or too many failed. */
export const passRateColor = (rate: number): 'success' | 'warning' | 'error' =>
  rate >= 100 ? 'success' : rate >= 80 ? 'warning' : 'error';

/** How long a run took; "—" while it is still running. */
export const formatDuration = (start: string, end?: string): string => {
  if (!end) return '—';
  const ms = dayjs(end).diff(dayjs(start));
  if (ms < 1000) return `${ms} ms`;
  const secs = Math.round(ms / 1000);
  if (secs < 60) return `${secs} s`;
  return `${Math.floor(secs / 60)} min ${secs % 60} s`;
};

export const formatRunDate = (value: string): string => dayjs(value).format('DD/MM/YYYY HH:mm');
